var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgIq = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M0 85.337h512v341.326H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#a2001d",
  d: "M0 85.337h512v113.775H0z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M0 312.888h512v113.775H0z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M219.186 246.069c-.083 0-.165.006-.248.007v-.007H189.83c1.476-5.702 6.649-9.931 12.806-9.931v-19.863c-18.254 0-33.103 14.85-33.103 33.103v16.551h49.655a3.314 3.314 0 013.31 3.31v6.62H156.29v19.862h86.069V269.24c0-12.776-10.395-23.171-23.173-23.171zm49.655 29.793v-59.587H248.98v79.449h33.103v-19.862zm66.207 0v-59.587h-19.862v59.587h-6.62v-19.861h-19.863v39.723h59.587v-19.862z",
  fill: "#496e2d"
})));

export default SvgIq;